import React from 'react';

import type { EStatus } from 'helpers/enums';

type Props = {
  label: string;
  status: EStatus;
};

const STATUS_CLASSES: Record<EStatus, string> = {
  success: 'border-[#b7eb8f] bg-[#f6ffed] text-[#52c41a]',
  error: 'border-[#ffa39e] bg-[#fff1f0] text-[#ff4d4f]',
  processing: 'border-[#91d5ff] bg-[#e6f7ff] text-[#1890ff]',
  default: 'border-[#596375] bg-[#fafafa] text-[#596375]'
};

function Tag({ label, status }: Props) {
  const tone = STATUS_CLASSES[status] ?? STATUS_CLASSES.default;
  return (
    <span
      className={`inline-flex h-auto rounded-xs border border-solid px-[7px] py-0.5 text-xs whitespace-nowrap ${tone}`}
    >
      {label}
    </span>
  );
}

export default Tag;
